import React from "react";

import Image from "next/image";
import { cn } from "@/lib/utils";

import { GROQImage } from "@/sanity/lib/definitions";

/**
 * Section label for this page: square icon tile against a white text tile.
 *
 * Figma draws it at a fixed 32px — a 32px tile centring a 24px icon, and 8px of
 * padding around 16px text — which is 4rem/3rem/1rem/2rem on this page's 8px rem
 * scale. The tile centres the icon rather than padding it, so the one caller that
 * swaps in a smaller icon (Companies, 16px) lands on its own Figma padding for
 * free. The shared Chip in components/global/ui carries other pages' proportions
 * and a bottom margin, so this page keeps its own rather than bending that one.
 */
export default function Chip({
  image,
  imageBG,
  text,
  textBG,
  className,
}: {
  image?: GROQImage;
  imageBG?: string;
  text: string;
  textBG?: string;
  className?: string;
}) {
  if (!text) return null;

  return (
    <div className={cn("inline-flex h-[4rem] items-center", className)}>
      {image && (
        <div
          className={cn(
            "flex h-[4rem] w-[4rem] shrink-0 items-center justify-center",
            imageBG || "bg-[#D9F9B9]",
          )}>
          <Image
            className="!h-[3rem] !w-[3rem] object-contain"
            src={image}
            alt=""
          />
        </div>
      )}

      <div
        className={cn(
          "flex h-full items-center px-[1rem]",
          textBG || "bg-white",
        )}>
        <p className="m-0 font-geist text-[2rem] leading-none whitespace-nowrap text-black">
          {text}
        </p>
      </div>
    </div>
  );
}
